/**
 * Smooth scrolling met Lenis.
 *
 * Lenis onderschept het wiel- en touchgedrag en laat de pagina met een lichte demping
 * naar de doelpositie lopen. Dat is wat de parallax in de hero rustig laat aanvoelen:
 * zonder demping springt de scroll per wielklik en schokt alles wat eraan hangt mee.
 *
 * De koppeling met GSAP is de standaardvorm: Lenis draait op de ticker van GSAP en
 * duwt ScrollTrigger bij elke scroll aan, zodat er maar één animatielus is.
 */

import Lenis from 'lenis';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

// Vastgehouden zodat andere onderdelen de scroll kunnen pauzeren -- een venster over de
// pagina heen bijvoorbeeld, want met alleen overflow op de body scrollt Lenis vrolijk door.
let instance = null;

export function getLenis() {
  return instance;
}

export default function initSmoothScroll() {
  // Wie aangeeft minder beweging te willen, krijgt gewoon de native scroll.
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    return null;
  }

  const lenis = new Lenis({
    lerp: 0.1,
  });

  instance = lenis;

  lenis.on('scroll', ScrollTrigger.update);

  gsap.ticker.add((time) => lenis.raf(time * 1000));

  // GSAP haalt normaal gesproken 'verloren' tijd in na een hapering; met een externe
  // scrollbron levert dat sprongen op.
  gsap.ticker.lagSmoothing(0);

  // Ankerlinks op dezelfde pagina door Lenis laten lopen, anders springt de browser
  // erheen en loopt de demping ernaast.
  document.addEventListener('click', (event) => {
    const link = event.target.closest('a[href^="#"]');

    if (!link) {
      return;
    }

    const hash = link.getAttribute('href');

    if (!hash || hash === '#' || !document.querySelector(hash)) {
      return;
    }

    event.preventDefault();
    lenis.scrollTo(hash);
  });

  return lenis;
}
